module.exports = __webpack_public_path__ + "static/media/peanutbutter_society_12.4adcd00a.mp3";